import React from 'react'
import { CivicLensMark } from '../../../components/Shared/CivicLensBrand'

// The CivicLens mark — two overlapping rings (Cameron, 2026-09-19). The drawing
// lives in components/Shared/CivicLensBrand.jsx so the signed-in app and these
// marketing pages cannot drift apart. Kept as its own module because the
// Header, the Footer and the auth layout all import it by this name, and
// `tone="onDark"` is still how the dark hero and footer ask for the light mark.
const LensMark = ({ size = 28, tone = 'default' }) => <CivicLensMark size={size} tone={tone} />

export default LensMark
